import axios from "axios";
import commonActions, { SetBallotListData, setDraftDependencyData } from "../../common.actions";
import getApiUrl from "../../helpers/api-urls";
import messages from '../../assets/i18n/en';
import { cacheManager, getApiUniqueRequestId, BallotActionForQueue, getMessage, decrypt, getFileName, formatDateToMMDDYYYY } from "../../helpers/util-common";
import { saveMetaDataAction, ConvertFileAction, DeleteDocumentAction } from '../../redux/action/documentUpload';
import { isEmpty } from "lodash";
import { getBallotfolderStatusAction } from "./ballotDetails";
import { ballotRecallToPrePublish } from "./openAPI";
import { Dispatch } from "redux";
import { setBallotItemInformationDetail, setNegativeRulingRationaleDetail } from "../../ballot.actions";
import { FLY_BALLOT_LEVEL_ID } from "../../../common.enum";
import en from "../../assets/i18n/en";


const getValueByKey = (key) => {
  const action = BallotActionForQueue.find(item => item.key === key);
  return action ? action.value : null;
};

export const getBallotRecapListAction: any = (ballotId: string, dispatch: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "ballotRecapList")+`?ballotId=${ballotId}`;
  axios
    .get(url)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
    });
};

export const getBallotDocumentsListAction: any = (dispatch: any, data: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("documents", "getBallotsList");
  const encodedPayload = encodeURIComponent(JSON.stringify(data));
  axios
    .get(`${url}?payload=${encodedPayload}`)
    .then(async (response: any) => {
      if (response && response.data.status) {
        let Result = response.data.content
        if (!isEmpty(Result)) {
          const data = Result.Data.map((item) => item.BallotFolder);

          await new Promise<void>((resolve) => {
            getBallotfolderStatusAction(data, dispatch, (folderRes) => {
              const folderMap = new Map(folderRes && folderRes.map(f => [f.Name, f]));
              Result.Data.forEach((item) => {
                const folderItem: any = folderMap.get(item.BallotFolder);
                if (folderItem) {
                  item.IsRepublish = folderItem.IsRepublish;
                  item.PublishStatus = folderItem.PublishStatus;
                  item.ManualPublishStatus = folderItem.ManualPublishStatus;
                  item.IsTermReplace = folderItem?.IsTermReplace
                }
              });
              resolve();
            });
          });

          callback(Result);
        }
        else {
          callback(response.data.content);
        }
        dispatch(SetBallotListData(response.data.content));
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
};

export const getCommitteeBallotItemsAction: any = (dispatch: any, data: any, callback: any,isExport?:boolean) => {
  dispatch(commonActions.setLoader(true));
  const ballotId = decrypt(window.location.pathname.substring(window.location.pathname.lastIndexOf("/") + 1));
  let url = getApiUrl("ballots", "getCommitteeBallotItems");
  url += `?payload=${JSON.stringify(data)}`;
  if (ballotId) {
    url += `&ballotId=${ballotId}`;
  }
  if(isExport){
    url += `&isExport=${isExport}`;
  }
  axios
    .get(url)
    .then((response: any) => {
      if (response && response.data.status) {
        callback(response.data.content);
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
};

export const getDownloadUrlAction: any = (dispatch: any, url: string, callback: any) => {
   commonActions.ValidateOktaToken((oktaResponse: any) => {
     let oktaToken = oktaResponse;
     dispatch(commonActions.setLoader(true));
  axios
    .get(url, {
      headers: {...oktaToken},
    })
    .then((response: any) => {
      if (response && response.status) {
        callback(response.data.Result);
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
   })
  
};
export const getActiveCommitteesAction = (dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("member","getActiveCommittees");
  axios
    .get(url)
    .then((response) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.status) {
        callback(response.data.content);
        dispatch(commonActions.setActiveCommittees(response?.data?.content));
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
};
export const getAllCommitteesAction = (dispatch: any) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("member","getAllCommittees");
  axios
    .get(url)
    .then((response) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.status) {
        dispatch(commonActions.setAllCommittees(response?.data?.content));
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
};

export const getBallotTypesAction: any = (dispatch: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("documents", "getBallotTypes");
  axios
    .get(url)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
    });
};
export const getActiveCommitteesFromIAAction = (dispatch: any, callback: (response: any) => void) => {
  let url = getApiUrl("documents", "getActiveCommitteesFromIA");
  axios
    .get(url)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.status) {
        callback(response.data.content);
      } else {
        // Handle error case
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const saveBallotHeaderAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "saveBallotHeader");
  axios
    .post(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        let folderReq = {
          Committee: data.CommitteeDesignation, 
          DocumentYear: data.BallotYear, 
          SequenceNumber: response.data?.content?.SequenceNumber, 
          CreatedBy: data.CreatedBy
        }
        postCreateNewFolderAction(folderReq, dispatch, (folderResponse: any) => {
          if (folderResponse?.Status) {
            dispatch(commonActions.setMessage(true, "", uniqueRequestId, response.data.content.StatusMessage));
            callback(response.data.content);
          } else {
            dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
            callback({});
          }
        });
      } else {
        dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
    });
};
export const updateBallotHeaderAction: any = (data: any, dispatch: any, isUpdate: boolean, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "saveBallotHeader");
  axios
    .put(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        dispatch(commonActions.setMessage(true, "", uniqueRequestId, response.data.content.StatusMessage));
        callback(response.data.content);
      } else {
        dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
    });
};


export const getAllBallotStatusAction: any = (dispatch: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("documents", "getAllBallotStatus");
  axios
    .get(url)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
    });
};

export const getUserListAction: any = (username: string, dispatch: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("documents", "getAppUserList")+`?username=${username}`;
  axios
    .get(url)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content, response.data.isUserOfficer);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
    });
};
export const getBallotItemsDownloadUrlAction = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
   let url = getApiUrl("openAPI", "getBallotItemsDownloadUrl", true);
  const combinedFileName = encodeURIComponent(`${data.fileName}.${data.fileType}`);
  url += `?filename=${data.fileName}&itemnumber=${data.itemNumber}&committee=${data.committee}`;
  let oktaToken = oktaResponse;
  axios
    .get(url, {
      headers: oktaToken
    })
    .then((response) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.Status) {
        callback(response.data?.Result);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
  })  
};

export const postCreateNewFolderAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let url = getApiUrl("openAPI", "createNewFolder", true);
    axios
      .post(url, data, { headers: oktaResponse })
      .then((response) => {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.Status) {
          callback(response.data);
        } else {
          callback({});
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
      });
  })
};

export const postMoveDocumentsAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let url = getApiUrl("openAPI", "moveDocuments", true);
    let oktaToken = oktaResponse;
     axios
    .post(url, data, {
      headers: oktaToken,
    })
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.ResponseStatus) {
        callback(response.data);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1021", uniqueRequestId));
    });
  }) 
 };

export const getBallotDesignationAction: any = (dispatch: any, callback: any, req: string | null = null) => {
  dispatch(commonActions.setLoader(true));
  const baseUrl  = getApiUrl("documents", "getBallotDesignation");
  const url = req ? `${baseUrl}?${req}` : baseUrl;
  axios
    .get(url, )
    .then((response: any) => {
      if (response && response.data.status) {
        callback(response.data.content);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setBallotDesignationData(response.data?.content))
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
}
export const downloadDocumentFromOneDriveID: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    let url = getApiUrl("openAPI", "downloadDocument", true);
  axios
    .post(url, data, {
      headers: oktaToken,
    })
    .then((response: any) => { 
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.Status) {
        callback(response.data);
      } else {
        dispatch(commonActions.setMessage(true, "3001", uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "3001", uniqueRequestId));
    });
  })
  
};
export const documentWebURLFromOneDriveID: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
  let oktaToken = oktaResponse;
  let url = getApiUrl("openAPI", "documentWebURL", true);
  axios
    .post(url, data, {
      headers: oktaToken
    })
    .then((response: any) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.Status) {
        callback(response.data);
      } else {
        dispatch(commonActions.setMessage(true, "3001", uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "3001", uniqueRequestId));
    });
  }) 
};
export const getBallotTrackingAction: any = (ballotId: string,committeeLevels:string, dispatch: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = `${getApiUrl("documents", "getBallotTracking")}?ballotId=${ballotId}&committeeLevels=${committeeLevels}`;
  axios
    .get(url)
    .then((response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
    });
};

export const getSNBallotTrackingAction: any = (dispatch: any, data: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("documents", "getSNBallotTracking");
  const encodedPayload = encodeURIComponent(JSON.stringify(data));
  axios
    .get(`${url}?payload=${encodedPayload}`)
    .then(async (response: any) => {
      dispatch(commonActions.setLoader(false));
      if (response && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
};

export const getDraftListAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "getDraftList");
  axios
    .post(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const getStandardMaintDesignationListAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "getStandardMaintDesignationList");
  axios
    .get(url)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const addQuickBallotItemAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  const { WITN, BallotDesignation, ...postData } = data;
  let url = getApiUrl("ballots", "addQuickBallotItem");
  axios
    .post(url, postData)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};
export const UpdateBallotTrackingItemAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  const { ...postData } = data;
  let url = getApiUrl("ballots", "updateBallotTracking");
  axios
    .put(url, postData)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data.content);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

const moveDocumentRequestWithUpdateMetaData: any = async (moveDocumentRequest: any, dispatch: any, metaUpdateRequest: any, callback: any, response: any, convertToPDFRequest: any, isConvertToPDF = false,checkDocumentExist=false) => {
  let moveSucceeded = false;
  let results; 
  const moveFilePromise = moveDocumentRequest.FileGuid.length > 0
    ? new Promise((resolve, reject) => {
        postMoveDocumentsAction(moveDocumentRequest, dispatch, (res: any) => {
          if (res?.ResponseStatus) {
            if (isConvertToPDF && convertToPDFRequest.FileGuid.length > 0) {
              ConvertFileAction(convertToPDFRequest, dispatch);
            }
            resolve(res);
            moveSucceeded = true;
          } else {
            reject("Document move failed");
          }
        });
      })
    : Promise.resolve();

  try {
    await moveFilePromise;

    if (moveSucceeded) {
      const postMovePromises: Promise<any>[] = [];
            if (metaUpdateRequest.FileInfo.length > 0) {
              postMovePromises.push(
                new Promise(resolve => {
                  saveMetaDataAction(metaUpdateRequest, dispatch, (res: any) => {
                    resolve(res);
                  });
                })
              );
            }
    
      results = await Promise.allSettled(postMovePromises);
    }
    
  } catch (moveError) {
  }
  finally {
    if(checkDocumentExist){
      callback(results); 
    }else{
      callback(response?.data); 
    }
  }
}

export const addItemToBallotTrackingAction: any = async (
  dispatch: any,
  data: any,
  callback: (response: any) => void,
  isAddballotTracking?: boolean
) => {
  dispatch(commonActions.setLoader(true));

  const url = getApiUrl("documents", "addItemToBallotTracking");
  const uniqueRequestId = getApiUniqueRequestId(url);

  try {
    // =========================================================
    // 1. PREPARE DOCUMENT GUIDS
    // =========================================================
    const fileGuids = data.items.flatMap(
      (ballotQueue: any) =>
        (ballotQueue.DocumentDetails ?? [])
          .map((document: any) => document.FileGUID)
          .filter(Boolean)
    );

    const moveDocumentRequest = {
      DestinationGroupIdentifier:
        data?.ballotDetailsData?.Committee,
      DestinationDocumentCategory: "BallotItems",
      DestinationFolder:
        data?.ballotFolderDetail?.FolderName,
      FileGuid: Array.from(new Set(fileGuids)),
      CreatedBy: data?.items?.[0]?.CreatedBy
    };

    // =========================================================
    // 2. PREPARE DOCUMENTS FOR PDF CONVERSION
    // =========================================================
    const eligibleDocumentForConvertToPDF = data.items
      .filter((item: any) => {
        if (
          !item?.OneDriveFileId ||
          !Array.isArray(item?.DocumentDetails)
        ) {
          return false;
        }

        const hasNonPdfNativeFile = item.DocumentDetails.some(
          (doc: any) =>
            doc?.FileGUID === item.OneDriveFileId &&
            doc?.Extension?.toLowerCase() !== "pdf"
        );

        const noPdfExistsInDocuments = item.DocumentDetails.every(
          (doc: any) =>
            doc?.Extension?.toLowerCase() !== "pdf"
        );

        return (
          hasNonPdfNativeFile &&
          noPdfExistsInDocuments
        );
      })
      .map((item: any) => item.OneDriveFileId);

    const convertToPDFRequest = {
      FileGuid: eligibleDocumentForConvertToPDF.filter(
        (fileGuid: string) =>
          moveDocumentRequest.FileGuid.includes(fileGuid)
      ),
      Format: "pdf"
    };

    // =========================================================
    // 3. MOVE DOCUMENTS
    // =========================================================
    await new Promise<void>((resolve, reject) => {
      moveDocumentRequestWithUpdateMetaData(
        moveDocumentRequest,
        dispatch,
        null,
        () => {
          resolve();
        },
        null,
        convertToPDFRequest,
        isAddballotTracking ?? true
      );
    });

    // =========================================================
    // 4. ADD ITEM TO BALLOT TRACKING API
    // =========================================================
    const response: any = await axios.post(
      url,
      data.items
    );

    if (!response?.data?.status) {
      dispatch(
        commonActions.setMessage(
          true,
          response?.data?.message,
          uniqueRequestId
        )
      );

      return;
    }

    // =========================================================
    // 5. PREPARE METADATA USING API RESPONSE
    // =========================================================
    const metaUpdateRequest = {
      FileInfo: (response?.data?.content || [])
        .filter(
          (item: any) => item?.OneDriveFileId
        )
        .map((item: any) => {
          const sourceItem = data.items.find(
            (x: any) =>
              x?.OneDriveFileId ===
              item?.OneDriveFileId
          );

          const nativeDocument =
            sourceItem?.DocumentDetails?.find(
              (document: any) =>
                document?.FileGUID ===
                item?.OneDriveFileId
            );

          return {
            FileGuid: item.OneDriveFileId,
            IncludeCachedData: false,

            DocumentMetadata: {
              ballotFolderId:
                data?.ballotFolderDetail?.BallotFolderId,

              documentYear:
                data?.ballotFolderDetail?.DocumentYear,

              sequenceNumber:
                data?.ballotFolderDetail?.SequenceNumber,

              itemNumber: item.ItemNumber,

              convertToPdf: true,
              isTerms: false
            },

            LogContext: {
              Action: "Moved",

              OldDocumentName:
                nativeDocument
                  ?.FileNameWithExtension || "",

              OldCategory: "Ballot Queue"
            }
          };
        })
    };

    // =========================================================
    // 6. UPDATE BALLOT ITEM METADATA
    // =========================================================
    if (metaUpdateRequest.FileInfo.length > 0) {
      await new Promise<void>((resolve, reject) => {
        saveMetaDataAction(
          metaUpdateRequest,
          dispatch,
          () => {
            resolve();
          }
        );
      });
    }

    // =========================================================
    // 7. CALLBACK
    // =========================================================
    callback(response.data);

    // =========================================================
    // 8. SUCCESS TOAST
    // =========================================================
    dispatch(
      commonActions.showSuccessToastMesage(
        true,
        "",
        "Ballot Item(s) successfully added to ballot tracking!"
      )
    );
  } catch (err) {
    console.error(
      "Error while adding item to ballot tracking:",
      err
    );
  } finally {
    // =========================================================
    // 9. HIDE LOADER
    // =========================================================
    dispatch(commonActions.setLoader(false));
  }
};

export const draftActionListAction: any = (dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "draftAction");
  axios
    .get(url)
    .then((response: any) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
};
export const deleteBallotItemAction: any = (data:any,dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "deleteBallotItem");
  axios
    .post(url,data)
    .then((response: any) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.content) {
        dispatch(commonActions.showSuccessToastMesage(true, "", `Ballot item(s) successfully permanently deleted!`));
        callback(response.data);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
};

export const sendItemToQueueAction = async (
  dispatch: any,
  data: any,
  callback: (response: any) => void
) => {
  dispatch(commonActions.setLoader(true));

  const url = getApiUrl("documents", "sendItemToQueue");
  const uniqueRequestId = getApiUniqueRequestId(url);

  try {
    const userDetail =
      cacheManager.getItem("userDetail") &&
      JSON.parse(cacheManager.getItem("userDetail"));

    // ---------------------------------------------------------
    // Prepare document GUIDs
    // ---------------------------------------------------------
    const NativefileGuid: string[] = [];
    const systemGeneratedfileGuid: string[] = [];
    const committeeToGuidsMap: Record<string, Set<string>> = {};

    for (const item of data.items || []) {
      const oneDriveId = item.oneDriveFileId;
      const documents = item.documentDetails || [];
      const committee =
        item.committee || data?.ballotDetailsData?.Committee;

      if (!committeeToGuidsMap[committee]) {
        committeeToGuidsMap[committee] = new Set<string>();
      }

      for (const doc of documents) {
        const fileGuid = doc.FileGUID;

        if (fileGuid) {
          // Native/original file
          if (
            fileGuid === oneDriveId &&
            !NativefileGuid.includes(fileGuid)
          ) {
            NativefileGuid.push(fileGuid);
            committeeToGuidsMap[committee].add(fileGuid);
          }
          // System generated file
          else if (
            fileGuid !== oneDriveId &&
            !systemGeneratedfileGuid.includes(fileGuid)
          ) {
            systemGeneratedfileGuid.push(fileGuid);
          }
        }
      }
    }

    // =========================================================
    // 1. DELETE SYSTEM GENERATED DOCUMENTS
    // =========================================================
    if (systemGeneratedfileGuid.length > 0) {
      await Promise.all(
        systemGeneratedfileGuid.map((fileGuid) => {
          if (!fileGuid) {
            return Promise.resolve();
          }

          return new Promise<void>((resolve, reject) => {
            DeleteDocumentAction(
              fileGuid,
              undefined,
              dispatch,
              () => {
                resolve();
              },
              false
            );
          });
        })
      );
    }

    // =========================================================
    // 2. MOVE NATIVE DOCUMENTS
    // =========================================================
    const committeeEntries = Object.entries(committeeToGuidsMap);

    for (const [committee, guidSet] of committeeEntries) {
      const moveDocumentRequest = {
        DestinationGroupIdentifier: committee,
        DestinationDocumentCategory: "BallotQueue",
        DestinationFolder: "BallotQueue",
        FileGuid: Array.from(guidSet),
        CreatedBy: userDetail.email
      };

      await new Promise<void>((resolve, reject) => {
        moveDocumentRequestWithUpdateMetaData(
          moveDocumentRequest,
          dispatch,
          null,
          () => {
            resolve();
          },
          null,
          null,
          false
        );
      });
    }

    // =========================================================
    // 3. CALL SEND ITEM TO QUEUE API
    // =========================================================
    const trackingIds = {
      BallotTrackingId:
        data?.items?.map((item) => item.ballotTrackingId) || []
    };

    const response: any = await axios.post(url, trackingIds);

    if (
      response?.data?.status !== true &&
      response?.data?.message !== 400
    ) {
      dispatch(
        commonActions.setMessage(
          true,
          response?.data?.message,
          uniqueRequestId
        )
      );

      // return;
    }

    // =========================================================
    // 4. UPDATE QUEUE METADATA
    // =========================================================
    const metaUpdateRequestBallotQueue = {
      FileInfo: (data.items || []).map((item) => {
        return {
          FileGuid: item.oneDriveFileId,
          IncludeCachedData: false,
          AutoGenerateSequence: true,
          FileName: `${getFileName(
            item?.committee ||
              data?.ballotDetailsData?.Committee,
            item?.standardDesigForFlyOverOrCOSFlyover ||
              item.standardDesig,
            item.workItem,
            formatDateToMMDDYYYY(undefined, "MMDDYYYY")
          )}.${item.documentDetails[0].Extension}`,
          DocumentMetadata: {
            ballotActionId: getValueByKey(item.ballotAction),
            workItemNumber: item.workItem,
            standardDesignation:
              item?.standardDesigForFlyOverOrCOSFlyover ||
              item.standardDesig,
            ballotLevel: data.ballotLevel,
            itemNumber: null,
            isFlyOver: item?.FlyBallotNumber && item?.FlyBallotLevelId === FLY_BALLOT_LEVEL_ID.FLYOVER ,
            fileSequence: null,
            isCOSFlyOver : item?.FlyBallotNumber && item?.FlyBallotLevelId === FLY_BALLOT_LEVEL_ID.COS_FLYOVER
          },
          LogContext: {
            Action: "Moved",
            OldDocumentName:
              item.documentDetails[0].FileNameWithExtension,
            OldCategory: "Ballot Items"
          }
        };
      })
    };

    await new Promise<void>((resolve, reject) => {
      saveMetaDataAction(
        metaUpdateRequestBallotQueue,
        dispatch,
        () => {
          resolve();
        }
      );
    });

    // =========================================================
    // 5. UPDATE BALLOT ITEM METADATA
    // =========================================================
    let metaDataPayloadBallotItems = (
      response?.data?.content?.Data || []
    ).map((ballotItem: any) => {
      return {
        FileGuid: ballotItem.OneDriveFileId,
        IncludeCachedData: false,
        DocumentMetadata: {
          ...data.ballotFolderInfo,
          itemNumber: ballotItem.ItemNumber,
          convertToPdf: true,
          isTerms: false
        }
      };
    });

    metaDataPayloadBallotItems =
      metaDataPayloadBallotItems.filter(
        (payload: any) => payload.FileGuid
      );

    if (metaDataPayloadBallotItems.length > 0) {
      await new Promise<void>((resolve, reject) => {
        saveMetaDataAction(
          {
            FileInfo: metaDataPayloadBallotItems
          },
          dispatch,
          () => {
            resolve();
          }
        );
      });
    }

    // =========================================================
    // 6. CALLBACK
    // =========================================================
    callback(response.data);

    // =========================================================
    // 7. SUCCESS TOAST
    // =========================================================
    dispatch(
      commonActions.showSuccessToastMesage(
        true,
        "",
        `Ballot Item(s) successfully sent back to queue!`
      )
    );
  } catch (err) {
    console.error("Error while sending item to queue:", err);
  } finally {
    // =========================================================
    // HIDE LOADER
    // =========================================================
    dispatch(commonActions.setLoader(false));
  }
};

export const cancelBallotFolderAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    dispatch(commonActions.setLoader(true));

    let url = getApiUrl("openAPI", "cancelBallotFolder", true);
    let oktaToken = oktaResponse;
    oktaToken["keep-body-params"] = "false";
    axios
      .delete(url, {
        data: data,
        headers: oktaToken,
      })
      .then((response) => {
        dispatch(commonActions.setLoader(false));
        const uniqueRequestId = getApiUniqueRequestId(url);
        callback(response);

      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
        callback({});
      });
  })
}

export const cancelBallotFolderFromBTAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "cancelBallotFolder");
  axios
    .delete(url, {
      data:data
    })
    .then((response) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response && response.status) {
        callback(response);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback({});
    });
}

export const updateBallotTrackingSequenceAction: any = (dispatch: any, data: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "updateBallotTrackingSequence");
  axios
    .put(url, data)
    .then((response: any) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.status) {
        callback(response.data);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
};

export const createWorkItemTrackingAction: any = (dispatch: any, data: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "createWorkItemTracking");
  axios
    .post(url, data)
    .then((response: any) => {
      if (response && response.data.status) {
        callback(response.data.content);
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
};

export const updateBallotQueue: any = (data: any, dispatch: any, updateDMS: boolean= true, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "updateBallotQueue");
  const { item } = data;
  const payload = {
    "BallotQueueId": item.BallotQueueId,
    "DocumentName": item.DocumentDetails?.length
      ? item.DocumentDetails[0].FileNameWithExtension
      : "",
    "BallotLevel": data.ballotLevel || item.BallotLevel,
    "Reason": "Ballot Level Updated",
    "UserName": item.userDetail?.email,
    "UserId": item.userDetail?.userId,
    "DraftId": Number(data.DraftId) > 0 ? data.DraftId : Number(item.DraftId) > 0 ? item.DraftId : null,
    "ItemDescription": updateDMS ? item.ItemDescription : data.ItemDescription || ""
  }
  axios
    .put(url, payload)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status && updateDMS) {
          let metaUpdateRequestBallotQueue = {
            FileInfo: [
                {
                  FileGuid: item.DocumentDetails?.length ? item.DocumentDetails[0]?.FileGUID : "",
                  IncludeCachedData: false,
                  DocumentMetadata: {
                    ballotActionId: getValueByKey(item.BallotAction),
                    workItemNumber: item.WorkItemNumber,
                    standardDesignation: item.Standard,
                    ballotLevel: data.ballotLevel,
                    itemNumber: null,
                    isFlyOver: false,
                    fileSequence: null,
                    isCOSFlyOver: false
                  },
                  LogContext:{
                    Action: "Ballot Level Updated",
                    OldDocumentName: item.DocumentDetails?.length
                      ? item.DocumentDetails[0].FileNameWithExtension
                      : "",
                    OldCategory:"Ballot Queue"
                  }
                
                }
              ]
          };

          saveMetaDataAction(metaUpdateRequestBallotQueue, dispatch, (responseMetaData: any) => {
            if (responseMetaData.length) {
              callback(response.data);
            } else {
              dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
            }
          });
      } else if (!updateDMS) {
        if (response && response.data.status) {
          callback(response.data.content);
          dispatch(commonActions.setLoader(false));
        } else {
          callback({});
          dispatch(commonActions.setLoader(false));
        }
      } else {
        dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1017", uniqueRequestId));
    });
};

export const getBallotDesignationListAction: any = (dispatch: any, callback: any, req: any = {}) => {
  dispatch(commonActions.setLoader(true));
  const url  = getApiUrl("documents", "getBallotDesignationList");
  axios
    .get(url, )
    .then((response: any) => {
      if (response && response.data.status) {
        callback(response.data.content);
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
}

export const deleteBallotQueue = (dispatch: any, data: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "deleteBallotQueue");
  const payload = {
    "BallotQueueId": data.BallotQueueId,
    "DocumentName": data.DocumentName,
    "UserName": data.UserName,
    "ReasonForDelete": data.ReasonForDelete
  };
  axios
    .delete(url+`?payload=${JSON.stringify(payload)}`)
    .then((response: any) => {
        if (response.data.status) {
          try {
             DeleteDocumentAction(data.FileGUID, null, dispatch, (responseStatus) => {
              dispatch(commonActions.setLoader(false));
              callback({status: responseStatus});
              dispatch(commonActions.showSuccessToastMesage(true, "", getMessage(messages, '6004.text').replace('@file', data.DocumentName)));
             }, false)
          } catch(e) {
            console.error("Error", e);
            const uniqueRequestId = getApiUniqueRequestId(url);
            dispatch(commonActions.setLoader(false));
            dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
          }
        }
    })
    .catch(err => {
      console.error("Error", err);
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "3003", uniqueRequestId));
    })
}

export const getBallotDetailAction: any = (dispatch: any, data: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "getBallotDetail");
  const encodedPayload = encodeURIComponent(JSON.stringify(data));
  axios
    .get(`${url}?payload=${encodedPayload}`)
    .then(async (response: any) => {
      if (response && response.data.status) {
        let Result = response.data.content
        if (!isEmpty(Result)){
            const data = Result.Data.map((item)=>item.BallotFolder)
           await getBallotfolderStatusAction(data,dispatch, (folderRes) => {
              const folderMap = new Map(folderRes && folderRes.map(f => [f.Name, f]));
               Result.Data.forEach((item) => {
                const folderItem : any = folderMap.get(item.BallotFolder);
                if (folderItem) {
                  item.IsRepublish = folderItem.IsRepublish;
                  item.PublishStatus = folderItem.PublishStatus;
                }
              });
            });
            callback(Result)
        }else{
          callback(response.data.content);
        }
        dispatch(SetBallotListData(response.data.content));
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      callback({});
      dispatch(commonActions.setLoader(false));
    });
};

export const recallBallotAction: any = async (payload: any, dispatch: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "recallBallot");
  ballotRecallToPrePublish({
      BallotFolderName: payload.BallotFolderName,
      CreatedBy: payload.UserEmail
    }, dispatch, (recallDMSResponse: any) => {
        if (!recallDMSResponse?.status) {
          return false;
        }
        axios
          .post(url, payload)
          .then((response: any) => {
            if (response && response.data.status) {
              callback(response.data);
              dispatch(commonActions.setLoader(false));
            } else {
              callback({});
              dispatch(commonActions.setLoader(false));
            }
          })
          .catch((err) => {
            callback({});
            dispatch(commonActions.setLoader(false));
          });
  });
};

export const getDraftDependencyAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "getDraftDependency");
  const encodedPayload = encodeURIComponent(JSON.stringify(data));
  axios
    .get(`${url}?payload=${encodedPayload}`)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        dispatch(setDraftDependencyData(response.data.content));
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const updateDraftDependencyAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "updateDraftDependency");
  axios
    .post(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.content) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1023", uniqueRequestId));
    });
};

export const validateBallotForceCloseAction : any =(ballotId: any, dispatch: any, callback:(response:any) => void)=>{
    dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("ballots", "validateBallotForceClose")}/${ballotId}`;
  axios
    .get(url)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.content) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "9193", uniqueRequestId));
    });
}

export const ballotForcedCloseProcessAction : any =(data: any, dispatch: any, callback:(response:any) => void)=>{
    dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "ballotForcedCloseProcess");
  axios
    .post(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.content) {
        callback(response.data);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "9193", uniqueRequestId));
    });
}

export const getDraftListOnDesignationAction: any = (designationId: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("ballots", "getDraftListOnDesignation")}/${designationId}`;
  axios
    .get(url)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "9194", uniqueRequestId));
    });
};
export const getDesignationListAction : any =(data: any, dispatch: any, callback:(response:any) => void)=>{
    dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "getDesignations");
  axios
    .post(url, data)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.content) {
        callback(response.data);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "9195", uniqueRequestId));
    });
}

export const getCommitteeFlyoverCountAction: any = (flyoverCommitteeID: any,flyoverBallotId:number | string, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("ballots", "getCommitteeFlyoverCount")}?committeeId=${flyoverCommitteeID}&ballotId=${flyoverBallotId}`;
  axios
    .get(url)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "9194", uniqueRequestId));
    });
};

export const getDraftListOnStatusAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "getDraftListOnStatus")+`?payload=${JSON.stringify(data)}`;
  axios
    .get(url)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};


export const getBallotItemInformationAction: any = (data: any, dispatch: Dispatch) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "getBallotItemInformation");

  const uniqueRequestId = getApiUniqueRequestId(url);
  url = `${url}/${data.BallotId}`;
  delete data.BallotId;
  axios
    .post(url, data)
    .then((response) => {
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        dispatch(setBallotItemInformationDetail(response.data.content));
      } else {
        dispatch(commonActions.setMessage(true, "8000", uniqueRequestId));
      }
    })
    .catch((error: Error) => {
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "8000", uniqueRequestId));
    });
};

export const getNegativeRulingRationaleAction: any = (data: any, dispatch: Dispatch) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("ballots", "getNegativeRulingRationale");
  const uniqueRequestId = getApiUniqueRequestId(url);
  url = `${url}/${data.BallotId}`;
  delete data.BallotId;
  axios
    .post(url, data)
    .then((response) => {
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        dispatch(setNegativeRulingRationaleDetail(response.data.content));
      } else {
        dispatch(commonActions.setMessage(true, "8001", uniqueRequestId));
      }
    })
    .catch((error: Error) => {
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "8001", uniqueRequestId));
    });
};

export const getPreSignedUrlAction = (dispatch: Dispatch, data: any, callback: Function) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "getAwsDoc");
  axios
    .post(url, data)
    .then((response) => {
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response?.data?.content);
      } else {
        dispatch(commonActions.setMessage(true, "3001"));
      }
    })
    .catch((error: Error) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "3001", uniqueRequestId));
    });
};

export const putReactivateOnrAction = (
  dispatch: Dispatch,
  payload: Record<string, string | number>,
  callback: Function
) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("ballots", "putReactivateOnr") + "/" + payload?.ItemId;
  const uniqueRequestId = getApiUniqueRequestId(url);
  delete payload?.ItemId;
  axios
    .put(url, payload)
    .then((response) => {
      if (response.data.status) {
        dispatch(
          commonActions.setMessage(
            true,
            "",
            "",
            getMessage(en, "8002")
              .text.replace("@ItemNumber", payload?.ItemNumber)
              .replace("@BallotNumber", payload?.BallotNumber)
          )
        );
        callback(true);
      } else {
        dispatch(commonActions.setMessage(true, "8003", uniqueRequestId));
      }
    })
    .catch(() => {
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "8003", uniqueRequestId));
    });
};